import { useEffect, useState } from "react";
import apiClient from "../api/apiClient";

interface EmergingCharacteristicsData {
  strengths: string[];
  weaknesses: string[];
}

interface UseEmergingCharacteristicsReturn {
  loading: boolean;
  error: string | null;
  data: EmergingCharacteristicsData | null;
  refetch: () => void;
}

const useEmergingCharacteristics = (
  schoolHash: string,
  classId: string,
  userId: string
): UseEmergingCharacteristicsReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<EmergingCharacteristicsData | null>(null);

  const fetchData = async () => {
    if (!schoolHash || !classId || !userId) return;

    setLoading(true);
    setError(null);
    try {
      const res = await apiClient.get(
        `/characterStrengthWeakness/student/${schoolHash}/${classId}/${userId}`
      );
      setData(res.data?.data);
    } catch (err: any) {
      setError(
        err?.response?.data?.message || "Failed to fetch emerging characteristics"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [schoolHash, classId, userId]);

  return { loading, error, data, refetch: fetchData };
};

export default useEmergingCharacteristics;
